<template>
    <div class="modal fade text-left" id="newEventModal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="newEvent">{{ $t("labels.event") }} - Type: {{ translatedEventType($store.state.currentEvent.type) }} </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                  
                   <form class="form">
                     <event-form :event="$store.state.currentEvent" v-on:saveevent="saveEvent" :type-list="typeList" ref="eventForm" v-bind:typeId.sync="typeId"></event-form>
                     <div class="form-actions">
                        <button type="button" class="btn btn-success" @click.prevent="saveEvent($refs.eventForm.clonedEvent)">
                            <i class="icon-note"></i> {{ $t("labels.save") }}
                       </button>
                     </div>
                   </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn grey btn-outline-secondary" data-dismiss="modal" ref='closeNewEventModal'>{{ $t("labels.close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LovService from '@/services/lov'
import EventService from '@/services/event'
import LovForm from '@/components/lov/LovForm'
import Progress from '@/components/patient/Progress'
import EventForm from '@/components/patient/EventForm'
import moment from 'moment'

export default {
    components: {
        Progress,
        LovForm,
        EventForm
    },
    data() {
        return {
            errors: [],
            types: ['health_state','event'],
            typeList: [],
            typeId: '',
            lov: {
                name: {},
                type: 'event',
                userId: this.$store.state.user._id
            },
            video: {},
            image: {},
            showLovForm: false,
            otherText: ''
        }
    },
    computed: {
        typeValue() {
            let result = this.typeList.find(t => t._id === this.typeId)
            let tpval = {}
            if (this.typeId != 'other') {
                tpval.id = result._id
                tpval.type = result.type
                tpval.name = result.name
            } else {
                tpval.id = 'other'
                tpval.type = 'other'
                tpval.name = {'en': 'Other'}
                tpval.other = this.otherText
            }
            return tpval
        },
        showLovText() {
            if (this.showLovForm) {
                return this.$t("labels.hideEventForm")
            } else {
                return this.$t("labels.addUserLov")
            }
        }
    },
    methods: {
        translatedEventType: function(eventType){
          return this.$t(`lovTypes.${eventType}`)
        },
        saveEvent: async function(event) {

            let loader = this.$loading.show({
                color: '#ccc',
                loader: 'spinner'
            },{
                after: this.$createElement('Progress')
            })
            this.errors = []
            if (!event.startDate) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.startDate")]))
            }
            if (!event.type) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.eventType")]))
            }
            if (!this.typeId) {
                this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.typeValue")]))
            }
            const allowedVideoTypes = ['video/mp4','video/x-flv','video/quicktime','video/3gpp','video/x-msvideo','video/x-ms-wmv']
            if (event.video && event.video.type) {
                if (!allowedVideoTypes.includes(event.video.type)) {
                    this.errors.push(this.$t("errors.wrongFiletype", [event.video.name]))
                }
                let videSizeMb = event.video.size/1024/1024
                if (videSizeMb > 50 ) {
                    this.errors.push(this.$t("errors.tooLarge", [event.video.name]))
                }
            }
            const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif']
            if (event.image && event.image.type) {
                if (!allowedImageTypes.includes(event.image.type)) {
                    this.errors.push(this.$t("errors.wrongFiletype", [event.image.name]))
                }
                let imageSizeMb = event.image.size/1024/1024
                if (imageSizeMb > 5) {
                    this.errors.push(this.$t("errors.tooLarge", [event.image.name]))
                }
            }
            if (event.periodic === true) {
                if (!event.dailyStart) {
                    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dailyStart")]))
                }
                //if (!event.dailyEnd) {
                //    this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dailyEnd")]))
                //}
               if (event.periodStep === 'weeks') {
                   if (!event.dayOfWeek) {
                        this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dayOfWeek")]))
                    }
               }
               if (event.periodStep === 'months') {
                    if (!event.dayOfMonth) {
                        this.errors.push(this.$t("errors.cantBeEmpty", [this.$t("labels.dayOfMonth")]))
                    }
               }
            }
            if (this.errors.length === 0) {
                event.typeValue = this.typeValue
                let formData = new FormData()
                formData.append('video', event.video)
                formData.append('image', event.image)
                formData.append('event', JSON.stringify(event))
                let result = await EventService.create(formData)
                if (result) {
                  this.$miniToastr.success(this.$t("flash.createSuccess", [this.$t("models.event")]))
                  this.$emit('refreshevents', result.data.event.type)
                  loader.hide()
                  this.$refs.closeNewEventModal.click()
                } else {
                  loader.hide()
                  this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
                }
            } else {
              loader.hide()
              this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
            }
            this.$store.state.currentProgress = 0
        },
        getValues: async function(tp) {
            let result = await LovService.all(tp, false)
            if (result) {
                this.typeList = result.data.filter(function (lv) {
                    return lv.userId === undefined || lv.userId === this.$store.state.user._id
                })
            }
            this.typeList = result.data
        },
    }
}
</script>

